import React from "react";
import { Outlet } from "react-router-dom";
import { Box, StyledEngineProvider, ThemeProvider } from "@mui/material";
import theme from "../../constants/theme";
import Footer from "../Footer";

// Pre-auth shell for the sign in / forgot / reset screens: dark background, no
// navbar, the shared logo on top, and the v2 footer pinned to the bottom. The
// dark color (#263238) matches the footer and the Home hero so the pre-auth and
// signed-in chrome share one dark surface.
export default function Layout() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            // 100vh counts the area behind the mobile address bar, so the
            // footer gets pushed below the fold and a scroll appears even when
            // the content fits. 100dvh tracks the visible viewport; it equals
            // 100vh on desktop, so this only changes mobile behavior.
            minHeight: "100vh",
            "@supports (min-height: 100dvh)": {
              minHeight: "100dvh",
            },
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#263238",
            color: "#ffffff",
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              px: { xs: 3, md: 4 },
              py: { xs: 5, md: 8 },
            }}
          >
            <Box
              component="img"
              src="/assets/logo-new.png"
              alt="AE Connect"
              sx={{
                width: "100%",
                // Cap on large screens so the logo stays proportionate to the
                // ~348px form rather than dominating the page.
                maxWidth: { xs: 240, sm: 320, md: 380 },
                mb: { xs: 4, md: 6 },
              }}
            />
            <Outlet />
          </Box>
          <Footer />
        </Box>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
